module.exports = __webpack_public_path__ + "img/top-bar.7c83bb8f.png";